import { scheduleService } from '@services/index';
import { useMutation } from '@tanstack/react-query';

export default function useMutationDeleteSchedule() {
	return useMutation({
		mutationFn: ({ scheduleId }: { scheduleId: number }) => scheduleService.deleteSchedule(scheduleId)
	});
}
